import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { ExternalLinkAltIcon } from "@patternfly/react-icons";

import { statutesDocuments } from "./data/statutesDocuments";

const StatutesPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={10}
              offset={1}
              md={8}
              mdOffset={2}
            >
              <Stack hasGutter>
                <StackItem>
                  <Content
                    component="h1"
                    style={{ textAlign: "center" }}
                  >
                    Statuty
                  </Content>
                </StackItem>

                <StackItem>
                  <Content
                    component="p"
                    style={{ textAlign: "center" }}
                  >
                    Statuty szkół wchodzących w skład CKZiU
                    w Wyrzysku.
                  </Content>
                </StackItem>
              </Stack>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardBody>
                  <Content>
                  <List isPlain>
                    {statutesDocuments.map((document) => (
                      <ListItem key={document.id}>
                        <a
                          href={document.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {document.title}{" "}
                          <ExternalLinkAltIcon />
                        </a>
                      </ListItem>
                    ))}
                  </List>
                  </Content>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default StatutesPage;